import {Avatar, Card, CardActionArea, CardHeader, Divider, Grid, Typography, useTheme} from "@mui/material";
import SvgIconBoosty from "../util/SvgIconBoosty";
import SvgIconYandexTips from "../util/SvgIconYandexTips";
import React from "react";
import {useLocale} from "../locale/Locale";
import SvgIconDALINK from "../util/SvgIconDALINK";

function AppDonate() {

    const {localeText} = useLocale()

    const xs = 12
    const sm = 4

    return (
        <>
            <Typography variant="h2" align="center">{localeText('supportTitle')}</Typography>
            <Typography align="center" mb={2}>{localeText('supportDescription')}</Typography>
            <Grid container spacing={2}>
                <Grid item xs={xs} sm={sm}>
                    <Card>
                        <CardActionArea
                            href="https://dalink.to/vittalucis"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconDALINK/>
                                    </Avatar>
                                }
                                title="DALINK"
                                subheader="@vittalucis"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm}>
                    <Card>
                        <CardActionArea
                            href="https://boosty.to/nanaki"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconBoosty/>
                                    </Avatar>
                                }
                                title="Boosty"
                                subheader="@nanaki"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm}>
                    <Card>
                        <CardActionArea
                            href="https://tips.yandex.ru/guest/payment/7856410"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconYandexTips/>
                                    </Avatar>
                                }
                                title={localeText('yandexTips')}
                                subheader="payment/7856410"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
            <Divider sx={{my: 4}}/>
        </>
    )

}

export default AppDonate
